import { boardDocumentStore } from '@/services/BoardDocument/store'
import { boardDocumentCategoryStore } from '@/services/BoardDocumentCategory/store'
import { notifyError, notifyMessage } from '@/services/notify'
import $ from 'jquery'

export const methods = {
  async reload() {
    this.loading = true

    this.loadCategories()

    if (this.boardDocument && this.boardDocument != undefined) {
      console.debug('in reload update...')
      this.description = this.boardDocument.description
      this.boardDocumentCategoryID = this.boardDocument.boardDocumentCategoryID

      if (this.boardDocument.documentID && this.boardDocument.documentID != undefined) {
        this.attachment = true
        this.loadCurrentBoardDocument()
      }

      //Update
      this.title = 'Update'

      this.loading = false
    } else {
      this.title = 'Add'
      this.loading = false
    }

    this.loading = false
  },

  open() {
    this.isOpen = true
    this.loadCategories()
    this.loading = false
  },

  async loadCategories() {
    console.debug('in loadCategories')
    await boardDocumentCategoryStore
      .dispatch('getBoardDocumentCategoryList', {
        hoaID: this.hoaId
      })
      .then(async ({ list }) => {
        if (list) {
          console.debug(JSON.stringify(list))
          this.categoryList = list.map(m => ({
            value: m.boardDocumentCategoryID,
            label: m.name
          }))
        }
      })
  },

  async replaceFile() {
    if (
      this.boardDocument &&
      this.boardDocument != undefined &&
      this.boardDocument.boardDocumentID > 0
    ) {
      const payload = {
        hoaID: this.boardDocument.hoaID,
        boardDocumentID: this.boardDocument.boardDocumentID,
        description: this.boardDocument.description,
        file: this.file
      }

      await boardDocumentStore.dispatch('uploadDocument', {
        payload: payload,
        done: ({ returnedFile }) => {
          if (returnedFile) {
            notifyMessage(`Successfully replaced the board document.`)
            this.closeModal()
          } else {
            notifyError('There was a problem replacing this board document.')
          }
        }
      })
    }
  },

  async loadCurrentBoardDocument() {
    if (
      !this.boardDocument ||
      !this.boardDocument.documentID ||
      this.boardDocument.documentID <= 0
    ) {
      return
    }

    try {
      const params = {
        boardDocumentID: this.boardDocument.boardDocumentID,
        asBase64: true
      }

      await boardDocumentStore.dispatch('getDocumentFile', {
        params: params,
        done: ({ details }) => {
          if (details) {
            if (this.isDebug == true)
              console.debug(
                ' - params' + JSON.stringify(params) + ' - this.getDocumentFile=' + details
              )

            this.base64pdf = details
            this.imageContent = null
          }
        }
      })
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
    }
  },

  async onFormSubmit() {
    if (this.description && this.description != undefined) {
      if (this.boardDocument) {
        await this.updateModal()
      } else {
        await this.addModal()
      }
    }
  },

  closeModal() {
    this.$emit('update:toggle', (this.documentToggle = !this.documentToggle))

    // auto-close modal
    $('#clickclose').click()
  },

  async addModal() {
    console.debug('in addModal...')
    if (this.description == '') {
      notifyError('Description is a required field.')
      return
    }

    this.loading = true

    await boardDocumentStore.dispatch('addBoardDocument', {
      hoaID: this.hoaId,
      documentID: null,
      boardDocumentCategoryID: this.boardDocumentCategoryID,
      description: this.description,
      done: async ({ details }) => {
        if (details) {
          this.loading = false

          // auto-close modal
          $('#clickclose').click()
        }
      }
    })
  },

  async updateModal() {
    if (!this.boardDocument || this.boardDocument == undefined) {
      notifyError('There was a problem updating this board document.')
      return
    }

    console.debug('updateModal...')

    this.loading = true

    const payload = {
      boardDocumentID: this.boardDocument.boardDocumentID,
      hoaID: this.boardDocument.hoaID,
      boardDocumentCategoryID: this.boardDocumentCategoryID,
      description: this.description ? this.description : null,
      documentID: this.boardDocument.documentID ? this.boardDocument.documentID : null
    }

    await boardDocumentStore.dispatch('updateBoardDocument', {
      payload: payload,
      done: () => {
        // auto-close modal
        this.$emit('update:toggle', (this.toggle = false))
        $('#clickclose').click()
        this.loading = false
      }
    })
  },

  async submitFile() {
    if (this.documentName == '') {
      notifyError('Document Name is a required field.')
      return
    }

    this.loading = true

    try {
      if (this.attachment == false) {
        await boardDocumentStore.dispatch('addBoardDocument', {
          hoaID: this.hoaId,
          documentID: null,
          boardDocumentCategoryID: this.boardDocumentCategoryID,
          description: this.description,
          done: async ({ details }) => {
            if (details && details != undefined && details.boardDocumentID > 0) {
              const payload = {
                hoaID: details.hoaID,
                boardDocumentID: details.boardDocumentID,
                description: details.description,
                file: this.file
              }

              console.debug('payload prior to store file=' + JSON.stringify(payload))

              await boardDocumentStore.dispatch('uploadDocument', {
                payload: payload,
                done: ({ returnedFile }) => {
                  if (returnedFile) {
                    this.$emit('update:toggle', (this.documentToggle = !this.documentToggle))
                    // auto-close modal
                    $('#clickclose').click()

                    notifyMessage(`Successfully uploaded the board document.`)
                  } else {
                    notifyError('There was a problem uploading this board document.')
                  }
                }
              })
            }
          }
        })
      }
    } catch (e) {
      notifyError(e)
    }
    this.loading = false
  },

  zoom(direction) {
    const amt = Math.sqrt(2)
    if (direction > 0) {
      this.scale *= amt
    } else {
      this.scale /= amt
    }

    // constrain to min/max
    this.scale = Math.max(0.5, Math.min(4, this.scale))
  }
}
